'use strict';

var cov_1wis9g921z = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/components/dashboard/dashboard.js',
        hash = '020b3f0a214edc37f9198ce6b7d9e2f71cdb9e87',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/components/dashboard/dashboard.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 6,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 13
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 16
                },
                end: {
                    line: 7,
                    column: 46
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 28,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 17
                    },
                    end: {
                        line: 5,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 29
                    },
                    end: {
                        line: 13,
                        column: 9
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 50
                    },
                    end: {
                        line: 15,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 62
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 23,
                        column: 4
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 14
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 23
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                }, {
                    start: {
                        line: 6,
                        column: 12
                    },
                    end: {
                        line: 8,
                        column: 13
                    }
                }],
                line: 6
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardController = function () {
    function DashboardController(OrdersTable) {
        var _this = this;

        _classCallCheck(this, DashboardController);

        cov_1wis9g921z.f[0]++;
        cov_1wis9g921z.s[0]++;

        OrdersTable.$search({
            state: 'IN_PAYMENT'
        }).$then(function (orders) {
            cov_1wis9g921z.f[1]++;
            cov_1wis9g921z.s[1]++;

            if (orders.length > 0) {
                cov_1wis9g921z.b[0][0]++;
                cov_1wis9g921z.s[2]++;

                _this.pendingOrder = orders[0];
            } else {
                cov_1wis9g921z.b[0][1]++;
            }
            /*orders.forEach((order) => {
                order.$load('paymentIfthen').$load('items');
                order.$items.$then((items) => items.$load('item'));
            })*/
        });

        cov_1wis9g921z.s[3]++;
        this.orders = OrdersTable.$search().$then(function (orders) {
            /*orders.forEach((order) => {
                order.$load('items');
                order.$items.$then((items) => items.$load('item'));
            });*/

            cov_1wis9g921z.f[2]++;
        });
    }

    _createClass(DashboardController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1wis9g921z.f[3]++;
        }
    }]);

    return DashboardController;
}();

cov_1wis9g921z.s[4]++;


angular.module('app').component('dashboard', {
    templateUrl: 'app/components/dashboard/dashboard.html',
    controller: DashboardController,
    bindings: {
        user: '<'
    }
});